export default function ProductImages($element) {
    class tmp_product_images_widget extends elementorModules.frontend.handlers.Base {
        getDefaultSettings() {
            return {
                selectors: {
                    container: ".tmp-product-images-container",
                    slides: ".tmp-product-images",
                    thumbs: ".tmp-product-images-thumbs",
                },
            };
        }

        getDefaultElements() {
            const w = this;
            const selectors = w.getSettings("selectors");
            return {
                $widget: w.$element,
                $slides: w.$element.find(selectors.slides),
                $thumbs: w.$element.find(selectors.thumbs),
            };
        }

        bindEvents() {}

        onInit(...args) {
            super.onInit(...args);
            const w = this;

            const swiper_settings = w.getSwiperSettings();
            if ("undefined" === typeof Swiper) {
                const asyncSwiper = elementorFrontend.utils.swiper;

                new asyncSwiper(w.elements.$slides, swiper_settings).then((newSwiper) => {
                    w.swiper = newSwiper;
                    w.initSwiper();
                });
            } else {
                w.swiper = new Swiper(w.elements.$slides, swiper_settings);
                w.initSwiper();
            }
        }

        initSwiper() {
            const w = this;
            const el_settings = w.getElementSettings();
            const swiper_settings = w.getSwiperSettings();

            w.swiper.init();

            if (w.elements.$thumbs.length) {
                const thumbs_settings = {
                    allowTouchMove: false,
                    slidesPerView: "auto", //el_settings.slides_per_view_thumb,
                    centeredSlides: true,
                    slideToClickedSlide: true,
                    spaceBetween: el_settings.thumbs_space_between_slides.size,
                    loop: swiper_settings.loop,
                };

                if ("undefined" === typeof Swiper) {
                    const asyncSwiper = elementorFrontend.utils.swiper;

                    new asyncSwiper(w.elements.$thumbs, thumbs_settings).then((newSwiper) => {
                        w.thumbs = newSwiper;
                        w.swiper.controller.control = w.thumbs;
                        w.thumbs.controller.control = w.swiper;
                    });
                } else {
                    w.thumbs = new Swiper(w.elements.$thumbs, thumbs_settings);
                    w.swiper.controller.control = w.thumbs;
                    w.thumbs.controller.control = w.swiper;
                }
            }
        }

        getSwiperSettings() {
            const w = this;
            const el_settings = w.getElementSettings();
            const mobile_settings = {
                slides_per_view: 1,
                slides_per_group: 1,
            };
            const tablet_settings = {
                slides_per_view: el_settings.slides_per_view,
                slides_per_group: el_settings.slides_per_group,
            };
            if (tablet_settings.slides_per_view > 3) {
                tablet_settings.slides_per_view = 3;
            }
            if (tablet_settings.slides_per_group > 3) {
                tablet_settings.slides_per_group = 3;
            }

            const swiper_settings = {
                init: false,
                grabCursor: true,
                initialSlide: 0,
                effect: el_settings.slide_effect,
                speed: el_settings.transition_speed,
                slidesPerView: mobile_settings.slides_per_view,
                slidesPerGroup: mobile_settings.slides_per_group,
                centeredSlides: el_settings.center_slide === "yes" ? true : false,
                spaceBetween: el_settings.space_between_slides.size,
                loop: el_settings.loop === "yes" ? true : false,
                navigation: {
                    nextEl: ".elementor-swiper-button-next",
                    prevEl: ".elementor-swiper-button-prev",
                },
                breakpoints: {
                    767: {
                        slidesPerView: tablet_settings.slides_per_view,
                        slidesPerGroup: tablet_settings.slides_per_group,
                    },
                    1025: {
                        slidesPerView: el_settings.slides_per_view,
                        slidesPerGroup: el_settings.slides_per_group,
                    },
                },
            };

            return swiper_settings;
        }
    }

    elementorFrontend.elementsHandler.addHandler(tmp_product_images_widget, {
        $element,
    });
}
